import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
export var ViewUtils = /*#__PURE__*/function () {
  function ViewUtils() {
    _classCallCheck(this, ViewUtils);
  }
  _createClass(ViewUtils, null, [{
    key: "viewMetadataCmp",
    value:
    /**
     * Comparator for .sort() that will order views bases on dependencies in creation order
     */
    function viewMetadataCmp(metadataA, metadataB) {
      if (!metadataA || !metadataB) {
        return 0;
      }
      if (metadataA.dependsOn && (metadataA.dependsOn.has(metadataB.target) || metadataA.dependsOn.has(metadataB.name))) {
        return 1;
      }
      if (metadataB.dependsOn && (metadataB.dependsOn.has(metadataA.target) || metadataB.dependsOn.has(metadataA.name))) {
        return -1;
      }
      return 0;
    }
  }]);
  return ViewUtils;
}();